let Tracking = (function () {


    let stagingPrefix = 'dev.';
    let localSuffix = '.local';

    let _downloads =  'a[data-file-download-name]';
    let _external_links =  'a[href^=http], a[href^=mailto], a[href^=tel]';

    let _add_to_cart = '.track-add-to-cart';
    let _convert_kitchen_to_cart = '.track-convert-kitchen-to-cart';
    let _go_to_checkout = '.track-go-to-checkout';
    let _go_to_cart = '.track-go-to-cart';
    let _go_to_payment_gateway = '#checkoutForm form :submit';



    let gTagClickEvent = (click_event_name) =>
    {

        if (window.dataLayer)
        {
            window.dataLayer.push({
                'event': click_event_name
            });
            console.log (click_event_name + ' was tracked');
        }
        else
        {
            console.log('no data layer??');
        }
    }

    let _trackImportantClicks =  () =>
    {
        $(document).on("click", _add_to_cart, function() {
            gTagClickEvent('addToCart');
        });
        $(document).on("click", _convert_kitchen_to_cart, function() {
            gTagClickEvent('addToCart');
        });
        $(document).on("click", _go_to_checkout, function() {
            gTagClickEvent('initiateCheckout');
        });
        $(document).on("click", _go_to_cart, function() {
            gTagClickEvent('initiateCart');
        });
        $(document).on("click", _go_to_payment_gateway, function(event) {
            gTagClickEvent('initiatePayment');
        });


    };

    let _externalLinksAndDownloads =  () =>
    {


        let _outboundTrack = (url) => {

            gtag('event', 'Outbound Links',
                {
                    'event_category': url,
                    'event_label': window.location.href,
                    'transport_type':'beacon',
                });

            setTimeout(function () {
                window.open(url, '_blank').focus();
            },100)
        };

        $(document).on("click", _external_links, function(event) {
            let $external_link = $(event.target).closest(_external_links);
            let href = $external_link[0] && $external_link[0].href ? $external_link[0].href : "";

            if( !href.includes(stagingPrefix) && !href.includes(localSuffix)  && !href.includes('mailto:')  && !href.includes('tel:')  )
            {
                if (window.gaID) {
                    event.preventDefault();
                    //console.log( href, ' outbound tracking' );
                    _outboundTrack(href);
                }
            } else {
                let filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
                if (href.match(filetypes))
                {
                    let extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;
                    if (extension)
                    {

                        if (window.gaID) {

                            gtag('event', 'Downloads',
                                {
                                    'event_category': href,
                                    'event_label': window.location.href,
                                    'transport_type':'beacon',
                                });
                        }
                    }
                }

                if (href.match(/^mailto\:/i))
                {
                    let label = href.replace(/^mailto\:/i, '');

                    if (window.gaID) {
                        gtag('event', 'Email',
                            {
                                'event_category': label,
                                'event_label': window.location.href,
                                'transport_type':'beacon',
                            });
                    }
                }

                if (href.match(/^tel\:/i))
                {
                    if (window.gaID) {
                        gtag('event', 'Telephone',
                            {
                                'event_category': label,
                                'event_label': window.location.href,
                                'transport_type':'beacon',
                            });
                    }
                }
            }
        });
    };

    let _documentDownloads =  () =>
    {

        $(document).on("click", _downloads, function(event) {
            let $download = $(event.target).closest(_downloads);
            //e.preventDefault();
            let filename = $download.data( 'file-download-name' );
            let filepath = $download.data( 'file-download-path' );
            //console.log (filepath, filename, "clicked");


            if (window.gaID) {
                gtag('event', 'Downloads',
                    {
                        'event_category': filepath,
                        'event_label': window.location.href,
                        'transport_type':'beacon',
                    });
            }
        });
    };


    let _virtualPageTrackingForms = () =>
    {
        var body = $('body');
        var step_title = null;
        var step_slug =  null;


        if (body.hasClass('merchant-site'))
        {
            if (body.hasClass('analytics_for_form_8')) // checkout form
            {
                step_slug = "/virtual/forms/checkout";
                if (body.hasClass('analytics_for_step_2'))
                {
                    step_title = "Checkout Step 2: Delivery";
                    step_slug = step_slug + "/step-2/"
                }
                if (body.hasClass('analytics_for_step_3'))
                {
                    step_title = "Checkout Step 3: Cardholder";
                    step_slug = step_slug + "/step-3/"
                }
            }
        }
        else // installer
        {
            if (body.hasClass('analytics_for_form_8')) // registration form
            {
                step_slug = "/virtual/forms/registration-steps";
                if (body.hasClass('analytics_for_step_2'))
                {
                    step_title = "Registration Step 2: Company Details";
                    step_slug = step_slug + "/step-2/"
                }
                if (body.hasClass('analytics_for_step_3'))
                {
                    step_title = "Registration Step 3: Primary Address";
                    step_slug = step_slug + "/step-3/"
                }
                if (body.hasClass('analytics_for_step_4'))
                {
                    step_title = "Registration Step 4: Legals";
                    step_slug = step_slug + "/step-4/"
                }
            }
            /*if (body.hasClass('analytics_for_form_10')) // checkout form
            {
                step_slug = "/virtual/forms/checkout";
                if (body.hasClass('analytics_for_step_2'))
                {
                    step_title = "Checkout Step 2: Delivery";
                    step_slug = step_slug + "/step-2/"
                }
                if (body.hasClass('analytics_for_step_3'))
                {
                    step_title = "Checkout Step 3: Cardholder";
                    step_slug = step_slug + "/step-3/"
                }
            }*/
            if (body.hasClass('analytics_for_form_18')) // checkout form
            {
                step_slug = "/virtual/forms/checkout";
                if (body.hasClass('analytics_for_step_2'))
                {
                    step_title = "Checkout Step 2: Account";
                    step_slug = step_slug + "/step-2/"
                }
                if (body.hasClass('analytics_for_step_3'))
                {
                    step_title = "Checkout Step 3: Cardholder";
                    step_slug = step_slug + "/step-3/"
                }
            }

        }

        if (step_title && step_slug)
        {

            if (window.dataLayer)
            {
                gtag('event', 'page_view',
                    {
                        'page_path': step_slug,
                        'page_title': step_title
                    });
                console.log (step_slug + ' ' + step_title + ' was tracked');
            }

        }

    };

    let init =  ()  =>
    {
        //_externalLinksAndDownloads();
        //_documentDownloads();
        _virtualPageTrackingForms();
        _trackImportantClicks();
    };

    return {
        init: init,
    }

})();


$( document ).ready( Tracking.init );